import axios from "axios";
import React, { Component } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
class SupplierForm extends Component {
  state = {
    id: "",
    name: "",
    contact: "",
    first_name: "",
    last_name: "",
    family_name: "",
    genre: "Masculin",
    email: "",
    tel: "",
    identity_number: "",
    title: "",
    yearId: "",
    years: [],
    profileId: "",
    profiles: [],
    error: "",
    currentStep: 0,
    btn: false,
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  goToStep = (currentStep) => {
    this.setState({ currentStep, error: "" });
  };

  edit = () => {
    this.form();
    this.getYear();
    this.getProfiles();
  };

  getYear = async () => {
    try {
      const response = await axios.get("years");

      if (response.status === 200) {
        this.setState({
          years: response.data.map((year) => ({
            value: year.id,
            label: year.year,
          })),
        });
      }
    } catch (error) {}
  };

  getProfiles = async () => {
    try {
      const response = await axios.get("profiles");

      if (response.status === 200) {
        const supplierProfile = response.data.find(
          (profile) => profile.model === "Supplier"
        );

        this.setState({
          profiles: response.data,
          profileId: supplierProfile?.id || "",
        });
      }
    } catch (error) {}
  };

  form = () => {
    const data = this.props.formData;

    this.setState({
      id: data ? data.id : "",
      name: data ? data.name || "" : "",
      contact: data ? data.contact || "" : "",

      first_name: data ? data.user?.first_name || "" : "",
      last_name: data ? data.user?.last_name || "" : "",
      family_name: data ? data.user?.family_name || "" : "",
      genre: data ? data.user?.genre || "Masculin" : "Masculin",
      email: data ? data.user?.email || "" : "",
      tel: data ? data.user?.tel || "" : "",
      yearId: data ? data.user?.yearId || "" : "",
      identity_number: data ? data.user?.identity_number || "" : "",

      title: data
        ? "Modifier les informations du fournisseur"
        : "Ajouter un fournisseur",

      error: "",
      currentStep: 0,
      btn: false,
    });
  };

  storeSupplier = () => {
    const data = {
      profileId: this.state.profileId,
      name: this.state.name,
      contact: this.state.contact,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      family_name: this.state.family_name,
      genre: this.state.genre,
      email: this.state.email || null,
      tel: this.state.tel || null,
      identity_number: this.state.identity_number || null,
      operation: this.state.id ? "Editer" : "Ajouter",
      yearId: this.state.yearId > 0 ? this.state.yearId : null,
    };

    this.setState({ btn: true });

    const request = this.state.id
      ? axios.put(`suppliers/${this.state.id}`, data)
      : axios.post("suppliers", data);

    request
      .then((response) => {
        this.setState({ btn: false });
        this.props.showModal();
        this.form();

        toast.success(response?.data?.msg || "Fournisseur enregistré.");
      })
      .catch((error) => {
        this.setState({
          btn: false,
          error: error.response?.data?.msg || "Une erreur est survenue",
        });

        toast.error(error.response?.data?.msg || "L’enregistrement a échoué.");
      });
  };

  renderInput = ({
    label,
    name,
    type = "text",
    icon,
    required = false,
    col = "col-md-4",
  }) => (
    <div className={`${col} mt-2`} key={name}>
      <div className="form-group has-icon-left">
        <label className="font-monospace fw-normal">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>

        <div className="position-relative mt-1">
          <input
            type={type}
            className="form-control form-control-sm"
            name={name}
            value={this.state[name] || ""}
            onChange={this.handleInput}
          />

          <div className="form-control-icon text-secondary">
            <FeatherIcon icon={icon} />
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const optionprofiles = this.state.profiles
      .filter((profile) => profile.model === "Supplier")
      .map((profile) => ({
        value: profile.id,
        label: profile.profile,
      }));

    return (
      <div>
        <Modal
          show={this.props.isModal}
          onHide={this.props.showModal}
          size="lg"
          dialogClassName="ev-form-dialog"
          contentClassName="ev-form-modal ev-form-modal--compact"
          onEntered={this.edit}
          backdrop="static"
        >
          <Modal.Header>
            <div className="ev-form-heading">
              <span className="ev-form-heading__icon">
                <FeatherIcon icon="truck" size="20" />
              </span>

              <div>
                <span className="ev-form-heading__eyebrow">
                  Dossier fournisseur
                </span>
                <Modal.Title>{this.state.title}</Modal.Title>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body className="row ev-form-body">
            {this.state.error && (
              <div className="col-12">
                <div className="ev-form-alert" role="alert">
                  <FeatherIcon icon="alert-circle" size="17" />
                  <span>{this.state.error}</span>
                </div>
              </div>
            )}

            <div
              className="col-12 ev-form-stepper"
              style={{ "--ev-step-count": 2 }}
              aria-label={`Étape ${this.state.currentStep + 1} sur 2`}
            >
              <div className="ev-form-stepper__track">
                <span
                  style={{
                    width: `${((this.state.currentStep + 1) / 2) * 100}%`,
                  }}
                />
              </div>

              {["Fournisseur", "Responsable"].map((label, index) => (
                <button
                  type="button"
                  key={label}
                  className={`${index === this.state.currentStep ? "is-active" : ""} ${
                    index < this.state.currentStep ? "is-complete" : ""
                  }`}
                  onClick={() => this.goToStep(index)}
                >
                  <span>
                    {index < this.state.currentStep ? (
                      <FeatherIcon icon="check" size="14" />
                    ) : (
                      index + 1
                    )}
                  </span>
                  <small>{label}</small>
                </button>
              ))}
            </div>

            {this.state.currentStep === 0 && (
              <>
                <div className="col-12 ev-form-section">
                  <span>
                    <FeatherIcon icon="truck" size="16" />
                  </span>
                  <div>
                    <strong>Informations du fournisseur</strong>
                    <small>Nom, contact principal et année scolaire</small>
                  </div>
                </div>

                {this.renderInput({
                  label: "Nom fournisseur",
                  name: "name",
                  icon: "home",
                  required: true,
                })}

                {this.renderInput({
                  label: "Contact fournisseur",
                  name: "contact",
                  icon: "phone-forwarded",
                })}

                <div className="col-md-4 mt-2">
                  <label className="font-monospace fw-normal">
                    Année scolaire
                  </label>

                  <div className="input-group mt-1">
                    <Select
                      className="form-control form-control-sm p-0"
                      value={this.state.years.filter(
                        (option) => option.value === this.state.yearId
                      )}
                      onChange={(select) => {
                        this.setState({ yearId: select?.value || "" });
                      }}
                      options={this.state.years}
                    />
                  </div>
                </div>

                {/* <div className="form-group col-md-4 mt-2 d-none">
                  <label className="font-monospace fw-normal">Profil</label>

                  <Select
                    className="form-control"
                    value={optionprofiles.filter(
                      (option) => option.value === this.state.profileId
                    )}
                    onChange={(select) => {
                      this.setState({ profileId: select?.value || "" });
                    }}
                    options={optionprofiles}
                  />
                </div> */}
              </>
            )}

            {this.state.currentStep === 1 && (
              <>
                <div className="col-12 ev-form-section">
                  <span>
                    <FeatherIcon icon="user-check" size="16" />
                  </span>
                  <div>
                    <strong>Responsable du fournisseur</strong>
                    <small>
                      Identité, téléphone, email et numéro administratif
                    </small>
                  </div>
                </div>

                {this.renderInput({
                  label: "Nom responsable",
                  name: "first_name",
                  icon: "user-plus",
                  required: true,
                })}

                {this.renderInput({
                  label: "Prénom responsable",
                  name: "last_name",
                  icon: "user-plus",
                })}

                {this.renderInput({
                  label: "Post-nom responsable",
                  name: "family_name",
                  icon: "user-plus",
                })}

                {this.renderInput({
                  label: "Email responsable",
                  name: "email",
                  type: "email",
                  icon: "mail",
                })}

                {this.renderInput({
                  label: "Téléphone responsable",
                  name: "tel",
                  type: "number",
                  icon: "phone-call",
                  required: true,
                })}

                {this.renderInput({
                  label: "Numéro d'identité",
                  name: "identity_number",
                  type: "number",
                  icon: "trello",
                })}

                <div className="col-md-4 mt-2">
                  <label className="font-monospace fw-normal">
                    Genre responsable
                  </label>

                  <div className="ev-choice-group">
                    <label
                      className="ev-choice"
                      htmlFor="supplier-masculin"
                    >
                      <input
                        id="supplier-masculin"
                        type="radio"
                        name="genre"
                        value="Masculin"
                        checked={this.state.genre === "Masculin"}
                        onChange={this.handleInput}
                      />
                      <span>Masculin</span>
                    </label>

                    <label
                      className="ev-choice"
                      htmlFor="supplier-feminin"
                    >
                      <input
                        id="supplier-feminin"
                        type="radio"
                        name="genre"
                        value="Feminin"
                        checked={this.state.genre === "Feminin"}
                        onChange={this.handleInput}
                      />
                      <span>Féminin</span>
                    </label>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <span className="ev-form-footer-note">
              <FeatherIcon icon="info" size="14" />
              Les champs marqués d’un * sont obligatoires
            </span>

            <button
              type="button"
              onClick={this.props.showModal}
              className="btn btn-light ev-form-button"
            >
              <FeatherIcon icon="x" size="16" />
              Fermer
            </button>

            {this.state.currentStep > 0 && (
              <button
                type="button"
                onClick={() => this.goToStep(this.state.currentStep - 1)}
                className="btn btn-light ev-form-button"
              >
                <FeatherIcon icon="arrow-left" size="16" />
                Précédent
              </button>
            )}

            {this.state.currentStep < 1 && (
              <button
                type="button"
                onClick={() => this.goToStep(this.state.currentStep + 1)}
                className="btn btn-primary ev-form-button"
              >
                Suivant
                <FeatherIcon icon="arrow-right" size="16" />
              </button>
            )}

            {this.state.currentStep === 1 && (
              <button
                type="button"
                onClick={this.storeSupplier}
                disabled={this.state.btn}
                className="btn btn-primary ev-form-button"
              >
                <FeatherIcon icon="check" size="16" />
                {this.state.btn ? "Enregistrement..." : "Sauvegarder"}
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default SupplierForm;
